import { HomeHero } from "../components/home/HomeHero";
import { HomeMarquee } from "../components/home/HomeMarquee";
import { HomeServices } from "../components/home/HomeServices";
import { HomeStudio } from "../components/home/HomeStudio";
import { HomeFinalCta } from "../components/home/HomeFinalCta";
import { Seo } from "../components/Seo";

export default function Home() {
  return (
    <>
      <Seo page="home" />
      <HomeHero />
      <HomeMarquee />
      <HomeServices />
      <HomeStudio />
      <HomeFinalCta />
    </>
  );
}
